import React, { PureComponent, useState } from 'react';
import { connect } from 'dva';
import { Card, Steps, Button, Row, Col, Checkbox, message, Spin, Tabs, Modal } from 'antd';
import styles from './Index.less';
import { isEmpty } from 'lodash';
import PageHeaderWrapper from '../../components/PageHeaderWrapper';
import IAMRole from '../../components/CloudAccounts/EditCloudAccountV2/IAMRole';
import Azure from '../../components/CloudAccounts/EditCloudAccountV2/Azure';
import GCP from '../../components/CloudAccounts/EditCloudAccountV2/GCP';
import { router } from 'umi';
import OverViewTabs from '@/components/CloudAccounts/EditCloudAccountV2/OverviewTab/index';
import ConfigurationTab from '@/components/CloudAccounts/EditCloudAccountV2/ConfigurationTab/index';
import { PATH_DASHBOARD } from '@/utils/routes/path';
import ReconnectCloudAccount from '@/components/CloudAccounts/EditCloudAccountV2/ReconnectCloudAccount/ReconnectCloudAccount';
import AccountName from '@/components/CloudAccounts/AccountName';
import { decryptAES, encryptAES } from '@/utils/utils';
import Link from 'umi/link';
import { formatMessage } from 'umi-plugin-react/locale';
import Exception from '@/components/Exception';
import CryptoJS from 'crypto-js';

const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;

const EditCloudAccountV2 = props => {
  const { allCloudAccountsList } = props;

  let cloudAccountData;
  if (allCloudAccountsList && allCloudAccountsList.length > 0) {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const cloudAccount = url.searchParams.get('cloudaccount');
    cloudAccountData = allCloudAccountsList.find(singleCloud => singleCloud.id === cloudAccount);
  }

  const existsInList = allCloudAccountsList.some(item => item.id === cloudAccountData?.id);
  if (!existsInList && !(cloudAccountData === undefined)) {
    return (
      <Exception
        type="403"
        linkElement={Link}
        desc={formatMessage({ id: 'app.exception.description.403' })}
        backText={formatMessage({ id: 'app.exception.back' })}
      />
    );
  }

  // * show the loading spinner if the data is not yet loaded
  if (!cloudAccountData) {
    router.push(PATH_DASHBOARD.setup.cloudAccounts);
    return;
  }

  // ~ update cloud account document
  const updateClick = updateValue => {
    const { dispatch, userName } = props;
    const {
      accountId,
      regions = [],
      policy,
      provider,
      orgId,
      id: cloudAccountId,
      protectionLevel,
    } = cloudAccountData;

    let payloadData = {
      accountName: updateValue.accountName,
      isActive: updateValue.isActive,
      interval: updateValue.interval,
      intervalStatus: updateValue.interval.toLowerCase() === 'off' ? false : true,
      regions,
      provider,
      updatedAt: new Date(),
      updatedBy: userName,
    };

    if (provider.toLowerCase() === 'aws') {
      payloadData = {
        ...payloadData,
        accountId,
        externalId: updateValue.AWSExternalID,
        policy,
        // cloudXrayConfig: {
        //   ...cloudAccountData.cloudXrayConfig,
        //   scanRunningInstances: updateValue.scanRunningInstances,
        //   updatedAt: new Date(),
        // },
      };
    }

    if (provider.toLowerCase() === 'azure') {
      let azureKeys = {
        clientId: updateValue.clientID,
        secret: updateValue.Secret,
        domain: updateValue.domain,
        subscriptionId: updateValue['Subscription ID'],
      };
      let encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(azureKeys),
        REACT_APP_SECRET
      ).toString();

      payloadData = {
        ...payloadData,
        userkeys: encryptedData,
      };
    }
    // ? if acc is adv than add scan running instance only
    if (protectionLevel === 'advanced' && updateValue.scanRunningInstances !== undefined) {
      payloadData = {
        ...payloadData,
        cloudXrayConfig: {
          ...cloudAccountData.cloudXrayConfig,
          scanRunningInstances: updateValue.scanRunningInstances,
          updatedAt: new Date(),
        },
      };
    }

    dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'edit',
          provider,
          orgId,
          id: cloudAccountId,
        },
        data: payloadData,
      },
    });
  };

  // * CDM
  React.useEffect(() => {
    const { dispatch } = props;
    // * on mount we need to update the cloud account data into our dva model
    // * right now we are going to update the status and test connection data only

    const payload = {
      testConnectionTypes: cloudAccountData.testConnectionTypes,
    };

    dispatch({
      type: 'cloudAccount/save',
      payload,
    });
  }, []);

  const isAdvancedAcc = cloudAccountData.protectionLevel === 'advanced';

  const renderProviderLogo = (provider, accName, userkeys, awsAccountId = '', isActive) => {
    return (
      <AccountName
        accountData={{ provider, accName, userkeys, awsAccountId, isActive }}
        size="large"
        showTag={false}
      />
    );
  };

  const handleDeleteAccount = async () => {
    const { dispatch } = props;
    await dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'delete',
          id: cloudAccountData.id,
          orgId: cloudAccountData.orgId,
        },
      },
    });

    await dispatch({
      type: 'cloudAccount/selectRemove',
      payload: cloudAccountData.id,
    });

    message.success('Cloud Account Deleted Successfully');
    Modal.destroyAll();
  };

  const handleDisbaledAccount = async () => {
    const { dispatch } = props;

    await dispatch({
      type: 'cloudAccount/update',
      payload: {
        params: {
          type: 'updateIsActiveKey',
          provider: cloudAccountData.provider,
          orgId: cloudAccountData.orgId,
          id: cloudAccountData.id,
        },
        data: {
          isActive: false,
        },
      },
    });

    await dispatch({
      type: 'cloudAccount/selectRemove',
      payload: cloudAccountData.id,
    });

    message.success('Cloud Account Disabled Successfully');
    Modal.destroyAll();
  };

  const handleConfirmCleanup = async () => {
    const { dispatch } = props;
    await dispatch({
      type: 'cloudAccount/runForceCleanup',
      payload: {
        cloudAccountData,
      },
    });
  };

  return (
    <PageHeaderWrapper
      title="Edit Cloud Account"
      content={
        <div
          style={{
            marginTop: 12,
          }}
        >
          {renderProviderLogo(
            cloudAccountData.provider,
            cloudAccountData.accountName,
            cloudAccountData.userkeys,
            cloudAccountData?.awsAccountId,
            cloudAccountData?.isActive
          )}
        </div>
      }
    >
      <Card bordered={false}>
        <Tabs defaultActiveKey="overview">
          <TabPane tab="Overview" key="overview">
            <OverViewTabs
              cloudAccountData={cloudAccountData}
              handleDeleteAccount={handleDeleteAccount}
              handleDisbaledAccount={handleDisbaledAccount}
              updateData={updateClick}
              confirmCleanup={handleConfirmCleanup}
            />
          </TabPane>
          <TabPane tab="Configuration" key="configuration">
            <ConfigurationTab
              cloudAccountData={cloudAccountData}
              handleDeleteAccount={handleDeleteAccount}
              handleDisbaledAccount={handleDisbaledAccount}
              updateData={updateClick}
              confirmCleanup={handleConfirmCleanup}
            />
          </TabPane>
        </Tabs>
      </Card>
    </PageHeaderWrapper>
  );
};

export default connect(({ user, cloudAccount, loading, organisation }) => ({
  cloudAccount,
  organisation: organisation.current,
  loading: loading.models.cloudAccounts,
  userName: user.currentUser.name,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
}))(EditCloudAccountV2);
